import React from "react";
import { Table, Button } from "reactstrap";
import ModalMini from "./MiniModal";

export default class TablaAlumnos extends React.Component {
  render() {
    if (!this.props.data) return null;
    console.warn(this.props);
    return (
      <Table hover className="mb-0">
        <thead>
          <tr>
          
            <th className="text-center">Planeta</th>
            <th className="text-center">Nombre</th>

            <th className="text-center">Descripción </th>

            <th className="text-center">Ver Detalle</th>
          </tr>
        </thead>
        <tbody>
          {this.props.data.map((e, index) => {
            return (
              <tr key={e.id}>
                 
                <td className="text-center">{e.planeta.descripcion}</td>
                <td className="text-center">{e.nombre}</td>

                <td className="text-center">
                  {e.tipoMinijuegoEntity.descripcion}
                </td>

                <td className="text-center">
                  <ModalMini mini={e}></ModalMini>
                </td>
              </tr>
            );
          })}
          <div>
            <nav
              aria-label="Page"
              className="d-flex w-100 justify-content-center  "
            >
              <ul className="pagination">
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(0)}
                >
                  <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">«</span>
                    <span className="sr-only"> Pagina Anterior</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link">{this.props.page}</a>
                </li>
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(1)}
                >
                  <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">»</span>
                    <span className="sr-only">Proxima Pagina</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/Mini/component/AlumnosList.js